// extracted by mini-css-extract-plugin
module.exports = {"slide":"add_slide_2SIJ7","slide-reverse":"add_slide-reverse_4ejMR","pageContent":"add_pageContent_3-ckA","card-wrapper":"add_card-wrapper_1a39v","footer":"add_footer_1cU1o"};